import axios from 'axios';
import cacheService from './cacheService';

const API_URL = process.env.REACT_APP_API_URL || 'https://bmbjewels.com/api/catalog';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor - check cache before making request
api.interceptors.request.use(
  async (config) => {
    // Only cache GET requests
    if (config.method === 'get' && config.cache !== false) {
      const cacheKey = cacheService.generateKey(config.url, config.params);
      const cached = await cacheService.get(cacheKey);
      
      if (cached) {
        // Return cached response by creating a custom adapter
        config.adapter = () => {
          console.log(`Cache hit for: ${config.url}`);
          return Promise.resolve({
            data: cached,
            status: 200,
            statusText: 'OK (from cache)',
            headers: {},
            config,
            cached: true
          });
        };
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - save successful responses to cache
api.interceptors.response.use(
  (response) => {
    // Only cache GET requests that weren't already cached
    if (
      response.config.method === 'get' && 
      response.config.cache !== false && 
      !response.cached &&
      response.status === 200
    ) {
      const cacheKey = cacheService.generateKey(response.config.url, response.config.params);
      const ttl = response.config.cacheTTL || cacheService.defaultTTL;
      
      console.log(`Caching response for: ${response.config.url} with TTL: ${ttl}ms`);
      cacheService.set(cacheKey, response.data, ttl);
    }
    
    return response;
  },
  (error) => {
    if (error.response) {
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      console.error('Network Error:', error.request);
    } else {
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;